import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { TmaisRafflesValidationSchema } from '../schemas/tmaisRaffles.schema'

interface UseCreateTmaisRaffleProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
  establishmentId?: string
}

const useCreateTmaisRaffle = ({ onSuccess, onError, establishmentId }: UseCreateTmaisRaffleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createTmaisRaffle'],
    mutationFn: async (form: TmaisRafflesValidationSchema) => {
      const [day, month, year] = form.select_winner_at.split('/');

      const formattedSelectWinnerAt = form?.select_winner_time_at 
        ? new Date(`${year}-${month}-${day}T${form?.select_winner_time_at}:00`).toISOString() 
        : form.select_winner_at

      const numberOfTickets = form.number_of_tickets ? form.number_of_tickets.value : undefined
      const maxTicketsPerUser = form.max_tickets_per_user ? Number(form.max_tickets_per_user.replace(/\D/g, '')) : undefined
      const pointsPerTicket = form.points_per_ticket ? Number(form.points_per_ticket.replace(/\D/g, '')) : undefined
      const selectWinnerOperationKlass = form?.select_winner_operation_klass ? form.select_winner_operation_klass.value : undefined
      
      const picturesAttachmentsAttributes = form?.pictures_attachments_attributes 
        ? form.pictures_attachments_attributes.map((item: any) => ({blob_id: item.id, content_type: item.file?.type})) 
        : undefined

      const raffle = {
        ...form,
        number_of_tickets: numberOfTickets,
        max_tickets_per_user: maxTicketsPerUser,
        points_per_ticket: pointsPerTicket,
        select_winner_operation_klass: selectWinnerOperationKlass,
        select_winner_at: formattedSelectWinnerAt,
        creator_establishment_company_branch_id: establishmentId,
        pictures_attachments_attributes: picturesAttachmentsAttributes
      }

      return privateAxios.post('/tmais/raffles', { raffle })
    },
    onSuccess,
    onError,
  })
}

export default useCreateTmaisRaffle